import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/reformas/page.tsx");
